import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import { isFlexible, isMetalCore, isRigid } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"

const isValidSilk = (values: EstimateValues, silk?: string) => {
  switch (silk) {
    case ESTIMATE_CONSTANT.印刷する面.なし.value:
    case ESTIMATE_CONSTANT.印刷する面["パターン面と同じ面(L1面)"].value:
      return true
    case ESTIMATE_CONSTANT.印刷する面.両面.value:
    case ESTIMATE_CONSTANT.印刷する面["パターン面とは逆の面(Ln面)"].value:
      return isRigid(values) || isFlexible(values) || isMetalCore(values)
    default:
      return false
  }
}

export default isValidSilk
